export const FeatureContext = {
  AlertOverview: 'alert_overview',
  AlertTriage: 'alert_triage',
} as const;
export type FeatureContext = (typeof FeatureContext)[keyof typeof FeatureContext];

export { default } from './AIResponseFeedbackV3';
export { default as AIResponseFeedbackV3 } from './AIResponseFeedbackV3';
export type { AIResponseFeedbackProps } from './AIResponseFeedbackV3';
